import { StoreInformationServiceModule } from 'services/data/storeInformation.service';

export const StorefrontSliderServiceModule = angular
    .module('app.components.storefrontSlider.storefrontSliderService', [
        StoreInformationServiceModule
    ]).service('storefrontSliderService', (
        $q,
        $rootScope,
        $timeout,
        storeInformationService
    ) => {
        var sliderUrl;
        var merchantStoreUrl;
        var frame;

        var VALID_PAGES = {
            home: 'home',
            product: 'product',
            category: 'category',
            page: 'page'
        };

        var currentItem = null;
        var currentPage = 'home';
        let storefrontState;
        let hasSliderBeenOpened;

        let themePreview = false;
        let themeTitle = null;

        var api = {
            //Slider functions
            setSliderUrl,
            getSliderUrl,
            openSlider,
            closeSlider,
            goToPage,
            getCurrentPage,
            getPageUrl,
            setIframeReference,
            enableStateChange,
            disableStateChange,
            getMerchantUrl,
            getIframeReference,
            getSliderHasOpened,
            setSliderHasOpened,

            //Detail page functions
            previewProductChanges,
            previewCategoryChanges,
            previewPageChanges,

            //Store editor functions
            sendMessage,
            previewStoreInfoChanges,
            previewEditableChanges,
            previewWidgetChanges,
            previewMenuChanges,
            highlightCategory,
            highlightEditable,
            highlightWidget,
            highlightDirective,
            unhighlightCategory,
            unhighlightEditable,
            unhighlightWidget,
            unhighlightDirective,
            unhighlightAll,
            scrollToTop,
            changePage,
            reloadTheme,
            showLoader,
            hideLoader,
            openPushMenu,
            closePushMenu,
            getStorefrontState,
            setStorefrontState,

            //theme preview
            setThemePreview,
            isThemePreview,
            setThemeTitle,
            getThemeTitle
        };

        return api;

        function getIframeReference() {
            return frame;
        }

        function getMerchantUrl(forceRefresh) {
            if (merchantStoreUrl && !forceRefresh) return $q.resolve(merchantStoreUrl);

            return storeInformationService.getStore().then((response) => {
                merchantStoreUrl = response.canonicalHost;
                return merchantStoreUrl;
            });
        }

        function setSliderUrl(url) {
            if (url === sliderUrl && getIframeReference()) return;
            sliderUrl = url;
            $rootScope.$emit('storefrontSliderService:sliderUrlChanged', sliderUrl);
        }

        function getSliderHasOpened() {
            return hasSliderBeenOpened;
        }

        function setSliderHasOpened() {
            hasSliderBeenOpened = true;
        }

        function getSliderUrl() {
            return sliderUrl;
        }

        function openSlider(width) {
            $rootScope.$emit('storefrontSliderService:openSlider', width || null);
        }

        function closeSlider() {
            $rootScope.$emit('storefrontSliderService:closeSlider');
        }

        function goToPage(page, item) {
            getMerchantUrl().then((storeUrl) => {
                switch (page) {
                    case VALID_PAGES.home:
                        setThemePreview(false);
                        setSliderUrl(storeUrl);
                        $timeout(() => {
                            enableStateChange();
                        });
                        currentItem = null;
                        break;
                    case VALID_PAGES.product:
                        setSliderUrl(`${storeUrl}/preview/product`);
                        $timeout(() => {
                            disableStateChange();
                        });
                        currentItem = item;
                        getPageUrl().then((pageUrl) => {
                            $rootScope.$emit('storefrontSliderService:setUrlBarAddress', pageUrl);
                        });
                        break;
                    case VALID_PAGES.category:
                        setSliderUrl(`${storeUrl}/preview/category`);
                        $timeout(() => {
                            disableStateChange();
                        });
                        currentItem = item;
                        getPageUrl().then((pageUrl) => {
                            $rootScope.$emit('storefrontSliderService:setUrlBarAddress', pageUrl);
                        });
                        break;
                    case VALID_PAGES.page:
                        setSliderUrl(`${storeUrl}/preview/page`);
                        $timeout(() => {
                            disableStateChange();
                        });
                        currentItem = item;
                        getPageUrl().then((pageUrl) => {
                            $rootScope.$emit('storefrontSliderService:setUrlBarAddress', pageUrl);
                        });
                        break;
                    default:
                        throw new Error('Invalid page name');
                }

                currentPage = page;
            });
        }

        function getCurrentPage() {
            return currentPage;
        }

        function getPageUrl() {
            return getMerchantUrl().then((storeUrl) => {
                if (!currentItem || !currentItem.seo.friendlyName) return storeUrl;

                switch (currentPage) {
                    case VALID_PAGES.product:
                        return `${storeUrl}/p/${currentItem.seo.friendlyName}`;
                    case VALID_PAGES.category:
                        return `${storeUrl}/c/${currentItem.seo.friendlyName}`;
                    case VALID_PAGES.page:
                        return `${storeUrl}/page/${currentItem.seo.friendlyName}`;
                    default:
                        return storeUrl;
                }
            });
        }

        function setIframeReference(iframeReference) {
            frame = iframeReference;
        }

        function sendMessage(sender, event, data) {
            var message = JSON.stringify({
                sender: sender,
                event: event,
                data: data
            });

            if (angular.isDefined(frame) && frame !== null) {
                frame.postMessage(message, sliderUrl);
            }
        }

        function sendMessageToTheme(event, data) {
            sendMessage('admin', event, data);
        }

        function openPushMenu() {
            sendMessageToTheme('openPushMenu');
        }

        function closePushMenu() {
            sendMessageToTheme('closePushMenu');
        }

        function previewProductChanges(productData) {
            sendMessageToTheme('previewProductChanges', productData);
        }

        function previewPageChanges(pageData) {
            sendMessageToTheme('previewPageChanges', pageData);
        }

        function previewCategoryChanges(categoryData) {
            sendMessageToTheme('previewCategoryChanges', categoryData);
        }

        function enableStateChange() {
            $rootScope.$emit('storefrontSliderService:stateChanged', true);
            sendMessageToTheme('enableStateChange');
        }

        function disableStateChange() {
            $rootScope.$emit('storefrontSliderService:stateChanged', false);
            sendMessageToTheme('disableStateChange');
        }

        /* Store Editor functions */

        function previewStoreInfoChanges(storeInfo) {
            sendMessage('admin-widget-editor', 'previewStoreInfoChanges', storeInfo);
        }

        function previewEditableChanges(editableData) {
            sendMessage('admin-widget-editor', 'previewEditableChanges', editableData);
        }

        function previewWidgetChanges(widget) {
            sendMessage('admin-widget-editor', 'previewWidgetChanges', widget);
        }

        function previewMenuChanges(menu) {
            sendMessage('admin-widget-editor', 'updateMenus', menu);
        }

        //Highlight section
        function highlightCategory(categoryId) {
            sendMessage('admin-widget-editor', 'highlightCategory', categoryId);
        }

        function highlightEditable(editableId) {
            sendMessage('admin-widget-editor', 'highlightEditable', editableId);
        }

        function highlightWidget(widgetId) {
            sendMessage('admin-widget-editor', 'highlightWidget', widgetId);
        }

        function highlightDirective(directiveName) {
            sendMessage('admin-widget-editor', 'highlightDirective', directiveName);
        }

        //Unhighlight section
        function unhighlightCategory() {
            sendMessage('admin-widget-editor', 'unhighlightCategory');
        }

        function unhighlightEditable() {
            sendMessage('admin-widget-editor', 'unhighlightEditable');
        }

        function unhighlightWidget() {
            sendMessage('admin-widget-editor', 'unhighlightWidget');
        }

        function unhighlightDirective(directiveName) {
            sendMessage('admin-widget-editor', 'unhighlightDirective', directiveName);
        }

        function unhighlightAll() {
            sendMessage('admin-widget-editor', 'unhighlightAll');
        }

        function scrollToTop() {
            sendMessage('admin-widget-editor', 'scrollToTop');
        }

        function changePage(toPage) {
            sendMessage('admin-widget-editor', 'changePage', toPage);
        }

        function reloadTheme() {
            sendMessage('admin-widget-editor', 'reloadTheme');
        }

        function showLoader() {
            $rootScope.$emit('storefrontSliderService:toggleLoader', true);
            api.isLoading = true;
        }

        function hideLoader() {
            $rootScope.$emit('storefrontSliderService:toggleLoader', false);
            api.isLoading = false;
        }

        function getStorefrontState() {
            return storefrontState;
        }

        function setStorefrontState(state) {
            storefrontState = state;
        }

        function setThemePreview(isPreview) {
            themePreview = isPreview;
        }

        function isThemePreview() {
            return themePreview;
        }

        function setThemeTitle(title) {
            themeTitle = title;
        }

        function getThemeTitle() {
            return themeTitle;
        }

        /* End Store Editor functions */
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/storefrontSlider/storefrontSlider.service.js